<ng-container>
  <div class="wrapper__form">
    <div
      class="d-flex flex-xl-row align-items-center mb-4 justify-content-between">
      <h2 class="wrapper__form__title h4-tipografia-govco mb-0">
        {{ proconText['tramite-sic-procon']['proteccion-requiere'] }}
      </h2>
    </div>

    <app-form
      [title]="' '"
      [fields]="formFieldsTipoProteccion"
      [withSubmitButton]="false"
      (changeAction)="validarFormularioTipoProteccion($event)"
      [idEntidad]="entidadId" />
    <br />

    <app-form
      *ngIf="formTipoProteccion.value?.tipoProteccion === 'PR_EG'"
      [title]="proconText['tramite-sic-procon']['efectividad-garantia']"
      [fields]="formFieldsEfectividadGarantia"
      [withSubmitButton]="false"
      (changeAction)="validarFormularioEfectividadGarantia($event)"
      [idEntidad]="entidadId" />

    <app-form
      *ngIf="formTipoProteccion.value?.tipoProteccion === 'PR_PIE'"
      [title]="proconText['tramite-sic-procon']['publicidad-enganiosa']"
      [fields]="formFieldsPublicidadEnganosa"
      [withSubmitButton]="false"
      (changeAction)="validarFormularioPublicidadEnganosa($event)"
      [idEntidad]="entidadId" />

    <app-form
      *ngIf="formTipoProteccion.value?.tipoProteccion === 'PR_PSIB'"
      [title]="proconText['tramite-sic-procon']['prestacion-servicio']"
      [fields]="formFieldsPrestacionServicios"
      [withSubmitButton]="false"
      (changeAction)="validarFormularioPrestacionServicios($event)"
      [idEntidad]="entidadId" />

    <app-form
      *ngIf="formTipoProteccion.value?.tipoProteccion === 'PR_PC'"
      [title]="proconText['tramite-sic-procon']['proteccion-contractual']"
      [fields]="formFieldsProteccionContractual"
      [withSubmitButton]="false"
      (changeAction)="validarFormularioProteccionContractual($event)"
      [idEntidad]="entidadId" />

    <span
      *ngIf="formTipoProteccion.value?.tipoProteccion === 'PR_PC'"
      class="form-label text3-tipografia-govco">
      {{ proconText['tramite-sic-procon']['articulo-42'] }}
    </span>

    <app-form
      *ngIf="formTipoProteccion.value?.tipoProteccion === 'PR_PVDC'"
      [title]="proconText['tramite-sic-procon']['proteccion-violacion']"
      [fields]="formFieldsViolacionDerechosConsumidor"
      [withSubmitButton]="false"
      (changeAction)="validarFormularioViolacionDerechosConsumidor($event)"
      [idEntidad]="entidadId"/>


    <app-cargue-archivos-tramite
      *ngIf="archivosPrecargados.length > 0"
      [idTipoTramite]="Constants.SIC_PROCON"
      [paso]="4"
      [idTramite]="tramiteSic?.id ?? 0"
      (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
      (archivosCargados)="validarArchivosCargados($event)"
      [enviar]="guardarArchivos"
      [codigoPretencion]="jsonReglaRequerido"
      [enviarEntidad]="false"
      [reglaRequerido]="JSON.stringify(jsonReglaRequerido)"
      [archivosPreCargados]="archivosPrecargados"
      (guardo)="subirArchivo($event)"/>
    <app-cargue-archivos-tramite
      *ngIf="archivosPrecargados.length === 0"
      [idTipoTramite]="Constants.SIC_PROCON"
      [paso]="4"
      [idTramite]="tramiteSic?.id ?? 0"
      (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
      (archivosCargados)="validarArchivosCargados($event)"
      [enviar]="guardarArchivos"
      [codigoPretencion]="jsonReglaRequerido"
      [enviarEntidad]="false"
      [reglaRequerido]="JSON.stringify(jsonReglaRequerido)"
      [archivosPreCargados]="archivosPrecargados"
      (guardo)="subirArchivo($event)"/>
      <div class="mt-3 text-muted small d-flex align-items-center" *ngIf="showPesoArchivos()">
        <i class="bi bi-info-circle me-2"></i>
        {{ 'copia_envio.peso_actual' | translate:{ peso: pesoArchivos } }}
      </div>
    <br/>
    <span
      class="form-label text3-tipografia-govco text-danger">
      {{ proconText['tramite-sic-procon']['texto-proteccion-requiere'] }}
    </span>
  </div>

  <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
    <div class="d-flex flex-column flex-md-row gap-2">
      <button
        type="submit"
        class="btn-govco fill-before-btn-govco w-auto"
        (click)="anterior()"
        onClick="nextItemAdvanceLineIHorizonalBack(event)"
        [attr.aria-label]="proconText['botones-envio']['atras']">
        {{ proconText['botones-envio']['atras'] }}
      </button>
      <button
        *ngIf="formTipoProteccion.value?.tipoProteccion"
        type="button"
        class="btn-govco fill-btn-govco w-auto"
        (click)="pasarAPretenciones($event, true)"
        [attr.aria-label]="proconText['botones-envio']['guardar-sin-enviar']">
        {{ proconText['botones-envio']['guardar-sin-enviar'] }}
      </button>

      <button
        *ngIf="formTipoProteccion.value?.tipoProteccion"
        type="submit"
        class="btn-govco fill-next-btn-govco w-auto"
        (click)="pasarAPretenciones($event, false)"
        [attr.aria-label]="proconText['siguiente']">
        {{ proconText['siguiente'] }}
      </button>
    </div>
    <!--[disabled]="formTipoProteccion.invalid || !isSelectedFormValid()"-->
  </div>
</ng-container>
